import React from 'react';

import { pdf } from '@react-pdf/renderer';

import PayrollVerificationDocument, { withoutHyphenation } from './payrollVerificationDocument';

// PRST-134 — render the Earnings History packet on press and hand it to the browser.
//
// pdf().toBlob(), not <PDFDownloadLink>: the link renders its document eagerly on mount, which for
// a multi-year request would lay out dozens of pages before the user has asked for anything (and
// is why QuoteEngine/ViewQuote carries a 3-second `mounted` workaround). AIReview took the same
// decision for the same reason.
//
// The anchor goes into the document before it is clicked and the object URL is released on a later
// tick — revoking in the same tick can cancel the download before the browser has finished reading
// the blob, which a few-KB CSV survives and a multi-hundred-KB PDF need not.
//
// Errors propagate so the page can surface them.

// The worker id, never the SSN — this filename is typed into emails and file shares.
export const pdfFileName = ({ cover = {}, criteria = {} } = {}) => {
  const worker = (cover.WorkerId ?? '') === '' ? 'worker' : String(cover.WorkerId);
  const from = (criteria.FromPerEnddate || '').replace(/-/g, '');
  const to = (criteria.ToPerEnddate || '').replace(/-/g, '');
  const range = from && to ? `-${from}-${to}` : '';
  return `earnings-history-${worker}${range}.pdf`;
};

export const downloadPayrollVerificationPdf = async ({ criteria, cover, months, reportDate } = {}) => {
  const blob = await withoutHyphenation(() =>
    pdf(
      <PayrollVerificationDocument criteria={criteria} cover={cover} months={months} reportDate={reportDate} />,
    ).toBlob(),
  );
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = pdfFileName({ cover, criteria });
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 0);
};

export default downloadPayrollVerificationPdf;
